module.exports = __webpack_public_path__ + "img/tab-none@2x.142a56a8.png";